import { useEffect, useState } from "react";
import { getCatalog } from "@/lib/drivego";

/**
 * Henter DriveGo-kataloget (caches i lib/drivego.js, så forside, booking og
 * footer deler ét kald). Returnerer `{ loading, error, tenant, categories, services }`.
 */
export const useCatalog = () => {
  const [state, setState] = useState({
    loading: true,
    error: null,
    tenant: {},
    categories: [],
    services: [],
  });

  useEffect(() => {
    let cancelled = false;
    getCatalog()
      .then((data) => {
        if (!cancelled) setState({ loading: false, error: null, ...data });
      })
      .catch((error) => {
        if (!cancelled) setState((s) => ({ ...s, loading: false, error }));
      });
    return () => {
      cancelled = true;
    };
  }, []);

  return state;
};

export default useCatalog;
